import React, { useState } from 'react';
import { LogIn } from 'lucide-react';
import { usePage } from '@inertiajs/react';
import { Button } from '../../../design-system/components';
export default function New() {
  const { props } = usePage();
  const appName = props.app_config?.company_name ?? 'Speakflow';
  const flash = props.flash;
  const [loading, setLoading] = useState(false);
  const handleSubmit = (e) => {
    setLoading(true);
    // Let the form submit naturally to OmniAuth
  };
  const csrfToken =
    typeof document !== 'undefined'
      ? document.querySelector('meta[name="csrf-token"]')?.content
      : undefined;
  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-secondary px-4">
      <div className="w-full max-w-sm">
        {/* Branding */}
        <div className="text-center mb-8">
          <h1 className="text-2xl font-semibold text-fg tracking-tight">
            {appName} Affiliates
          </h1>
          <p className="mt-2 text-sm text-fg-tertiary">Admin Portal</p>
        </div>

        {/* Sign-in card */}
        <div className="bg-surface rounded-xl shadow-sm border border-edge-strong p-8">
          {/* Error flash */}
          {flash?.alert && (
            <div className="mb-6 rounded-lg bg-danger-50 border border-danger-200 px-4 py-3 text-sm text-danger-700">
              {flash.alert}
            </div>
          )}

          <div className="text-center space-y-6">
            <p className="text-sm text-fg-secondary">
              Sign in with your {appName} account to access the admin dashboard.
            </p>

            <form action="/auth/speakflow" method="post" data-turbo="false" onSubmit={handleSubmit}>
              {csrfToken && <input type="hidden" name="authenticity_token" value={csrfToken} />}
              <input type="hidden" name="auth_type" value="admin" />
              <Button
                type="submit"
                variant="secondary"
                disabled={loading}
                loading={loading}
                className="w-full py-3"
                leadingIcon={!loading ? <LogIn size={20} /> : undefined}
              >
                {loading ? 'Redirecting...' : `Sign in with ${appName}`}
              </Button>
            </form>
          </div>
        </div>

        {/* Footer link */}
        <p className="mt-6 text-center text-xs text-fg-tertiary">
          Not an admin?{' '}
          <a href="/" className="text-fg hover:text-fg-secondary">
            Back to home
          </a>
        </p>
      </div>
    </div>
  );
}
